import Path from "../../services/paths";
import DownloadXlxActions from "../actions/downloadXlxActions";
import utils from "../common/utils";
import axios from "axios";
import CustomToast from '../../util-functions/customToast.jsx'

class DownloadReportFAFBXlxMiddleware {
    static downloadXlx(selectedCategory,
        selectedBrand,
        selectedSku,
        selectedRegion,
        selectedReportType,
        selectedGraphType,
        selectedYear,
        selectedCoreType,
        selectedStandPoint,
        selectedIntervention,
        selectedActiveStatus,
        selectedIsVolume,
        selectedCut,
        selectAllMSKU) {

        let url = `${Path.POST_DOWNLOAD_FAFBReport_XLX}?`;

        if (Array.isArray(selectedCategory)) {
            selectedCategory.forEach(element => {
                url += `category=${element}&`;
            });
        }

        if (Array.isArray(selectedBrand)) {
            selectedBrand.forEach(element => {
                url += `brand=${element}&`;
            });
        }
        if (Array.isArray(selectedSku) && !selectAllMSKU) {
            selectedSku.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }

        if (Array.isArray(selectedCategory)) {
            selectedRegion.forEach(element => {
                url += `region=${element}&`;
            });
        }

        if (Array.isArray(selectedCoreType)) {
            selectedCoreType.forEach(element => {
                url += `core_type=${element}&`;
            });
        }

        if (selectedIntervention !== 'Human Intervened' && selectedReportType.length > 0 && selectedReportType[0].label === 'Weekly') {
            url += `is_ytd=${false}&`;
            url += `is_weekly=${true}&`
        }

        if (selectedIntervention === 'Human Intervened') {
            url += `is_hi=${false}&`;
        }
        else {
            url += `is_hi=${false}&`;
        }

        if (selectedIntervention !== 'Human Intervened' && selectedReportType.length > 0 && selectedReportType[0].label === 'Monthly') {
            url += `is_ytd=${false}&`;
            url += `is_weekly=${false}&`;
        }

        if (selectedIntervention !== 'Human Intervened' && selectedReportType.length > 0 && selectedReportType[0].label === 'YTD') {
            url += `is_ytd=${true}&`;
            url += `is_weekly=${false}&`;
        }

        if (selectedGraphType.length > 0 && selectedGraphType[0].label === 'Primary') {
            url += `is_primary=${true}&`;
        } else {
            url += `is_primary=${false}&`;
        }
        if (selectedYear.length > 0) {
            url += `year=${selectedYear[0].value}&`;
        }
        if(selectedActiveStatus.length>0){
            if(selectedActiveStatus[0].label==='Activated'){url += `activated=${1}&`;}
            if(selectedActiveStatus[0].label==='Non-Activated'){url += `activated=${0}&`;}
            if(selectedActiveStatus[0].label==='All'){url += `activated=${1}&activated=${0}&`;}
        }
        if (selectedIsVolume[0].value || !selectedIsVolume[0].value) {
            url += `is_case=${selectedIsVolume[0].value}&`;
        }
        if (selectedCut) {
            url += `pivot=${selectedCut}&`;
        }
        if (selectAllMSKU || !selectAllMSKU) {
            url += `msku_select_all=${selectAllMSKU}&`;
        }
        url += `standpoint=${selectedStandPoint.length > 0 ? selectedStandPoint[0] : 43}&`;
        url = url.slice(0, -1);

        return dispatch => {
            dispatch(DownloadXlxActions.downloadXlxRequest());
            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        responseType: 'blob',
                        headers: {
                            Authorization: `Bearer ${token}`
                        },

                    })
                        .then(res => {
                            if (res.error) {
                            } else {
                                let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=') + 1,)
                                const url = window.URL.createObjectURL(new Blob([res.data]));
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download', fileName); //or any other extension
                                document.body.appendChild(link);
                                link.click();
                                CustomToast('success', 'Download Successful')
                                dispatch(DownloadXlxActions.downloadXlxSuccessul(res));
                            }
                        })
                        .catch(error => {
                            CustomToast('error', 'Download Failed!')
                            dispatch(DownloadXlxActions.downloadXlxFailed(error));
                        });
                })
                .catch(error => {
                    dispatch(DownloadXlxActions.downloadXlxFailed(error));
                });
        };
    }
}

export default DownloadReportFAFBXlxMiddleware;